import React from "react";
import AboutBlock from "../AboutBlock/AboutBlock";
import ButtonScroll from "../ButtonScroll/ButtonScroll";
import Projects from "../Projects/Projects";
import Skills from "../Skills/Skills";
function About() {
  return (
    <>
      <AboutBlock />
      <Skills />
      <Projects />
      <ButtonScroll />
    </>
  );
}

export default About;
